module.exports = __webpack_public_path__ + "static/media/tds-logo.57d3d139.png";